import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RelationshipSetupComponent } from '@playbook/modules/relationship-tracking/modules/relationship-setup/components/relationship-setup/relationship-setup.component';

const routes: Routes = [
  {
    path: '',
    component: RelationshipSetupComponent,
    data: {
      title: 'Create Relationship',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class RelationshipSetupRoutingModule {}
